"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleSign = exports.StyleImgWebmotors = exports.StyleImgSantanderi18nAr = exports.StyleImgSantanderi18n = exports.StyleImgSantander = exports.StyleImgParceiro = exports.StyleImgDemotores = exports.StyleImgCarroya = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _img = _interopRequireDefault(require("webmotors-react-pj/img"));
var _responsive = _interopRequireDefault(require("webmotors-react-pj/tokens/responsive"));
const StyleSign = exports.StyleSign = _styledComponents.default.div.withConfig({
  displayName: "StyleSign",
  componentId: "sc-14e2fni-0"
})(["display:flex;align-items:center;span{display:flex;}margin-top:16px;@media ", "{margin-top:0px;}"], _responsive.default.lg);
const StyleImgWebmotors = exports.StyleImgWebmotors = _styledComponents.default.img.withConfig({
  displayName: "StyleImgWebmotors",
  componentId: "sc-14e2fni-1"
})(["height:16px;transform:translateY(2px);"]);
const StyleImgSantander = exports.StyleImgSantander = _styledComponents.default.img.withConfig({
  displayName: "StyleImgSantander",
  componentId: "sc-14e2fni-2"
})(["height:16px;margin-left:16px;"]);
const StyleImgSantanderi18n = exports.StyleImgSantanderi18n = _styledComponents.default.img.withConfig({
  displayName: "StyleImgSantanderi18n",
  componentId: "sc-14e2fni-3"
})(["height:32px;margin-left:28px;"]);
const StyleImgSantanderi18nAr = exports.StyleImgSantanderi18nAr = _styledComponents.default.img.withConfig({
  displayName: "StyleImgSantanderi18nAr",
  componentId: "sc-14e2fni-4"
})(["height:60px;margin-left:28px;"]);
const StyleImgCarroya = exports.StyleImgCarroya = (0, _styledComponents.default)(_img.default).withConfig({
  displayName: "StyleImgCarroya",
  componentId: "sc-14e2fni-5"
})(["height:28px;margin-left:28px;"]);
const StyleImgParceiro = exports.StyleImgParceiro = (0, _styledComponents.default)(_img.default).withConfig({
  displayName: "StyleImgParceiro",
  componentId: "sc-14e2fni-6"
})(["height:32px;margin-left:28px;"]);
const StyleImgDemotores = exports.StyleImgDemotores = (0, _styledComponents.default)(_img.default).withConfig({
  displayName: "StyleImgDemotores",
  componentId: "sc-14e2fni-7"
})(["height:60px;margin-left:28px;"]);